import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { RULES } from "../../data/content";
import { Reveal, SectionHeading } from "../shared/Primitives";

export const Rules = () => {
  return (
    <section id="reglamento" data-testid="rules-section" className="bg-[#F5F1EA] py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <SectionHeading
                overline="Convivencia"
                title="Reglamento interno"
                subtitle="Normas que garantizan el orden, el respeto y el buen uso de los espacios para todos los residentes."
              />
            </div>
          </div>

          <div className="lg:col-span-8">
            <Reveal>
              <Accordion type="single" collapsible className="w-full" data-testid="rules-accordion">
                {RULES.map((rule, i) => (
                  <AccordionItem
                    key={rule.category}
                    value={`rule-${i}`}
                    data-testid={`rule-item-${i}`}
                    className="border-b border-[#B2967D]/30"
                  >
                    <AccordionTrigger
                      data-testid={`rule-trigger-${i}`}
                      className="py-6 text-left text-lg font-bold text-black hover:no-underline hover:text-[#7D5A44]"
                    >
                      <span className="flex items-center gap-5">
                        <span className="text-xs font-bold text-[#B2967D]">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        {rule.category}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 pl-12 text-lg font-light text-black/60 leading-relaxed">
                      {rule.text}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
